import { Services } from "../../services/Services.js";
import { RemoteService } from "./RemoteService.js";

export class ApiService extends RemoteService {

    constructor(servicePath, authManager, options = {}) {

        const serviceUrl = ApiService.createServiceUrl(servicePath);
        const defaultOptions = Object.assign({
            baseUrl: serviceUrl,
            authManager,
            defaultAuth: { type: 'cookie' },
            defaultContentType: 'json',
            defaultResponseType: 'json',
        }, options || {});

        super(defaultOptions);

    };

    static createServiceUrl(servicePath) {

        const config = Services.get('config');

        let baseUrl = ApiService.normalizePath(config.baseUrl, true),
            basePath = ApiService.normalizePath(config.apiBaseUrl);

        servicePath = ApiService.normalizePath(servicePath);

        return baseUrl + basePath + servicePath;

    };

    static normalizePath(path, skipOpeningCheck = false) {

        if (path === undefined)
            return '';
        if (path === null)
            return '';
        if (path === '')
            return path;
        if (!skipOpeningCheck && path.at(0) != '/')
            path = '/' + path;
        if (path.at(-1) == '/')
            path = path.slice(0, path.length - 1);

        return path;

    };

    async call(method, path, data, options) {

        path = ApiService.normalizePath(path);

        return super.call(method, path, data, options);

    };

    async get(path, data, options) {

        return this.call('GET', path, data, options);

    };

    async put(path, data, options) {

        return this.call('PUT', path, data, options);

    };

    async post(path, data, options) {

        return this.call('POST', path, data, options);

    };

    async delete(path, data, options) {

        return this.call('DELETE', path, data, options);

    };

}
